/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col, UncontrolledTooltip } from "reactstrap";

export default function Services() {
  return (
    <div className="section section-basic" id="services">
      <img alt="..." className="path" src={require("assets/img/path1.png")} />
      <Container>
        <div className="space-50" />
        <div id="images">
          <div className="title">
            <h3 className="mb-3">Services</h3>
          </div>
          <Row className="mt-5 mt-sm-5 text-center">
            <Col className="mt-5 mt-sm-0" sm="3" xs="6" lg="4">
              <small className="d-block text-uppercase font-weight-bold mb-4">
                Internet of Things (IoT)
              </small>
              <img
                id="iot"
                alt="..."
                className="img-fluid rounded-circle shadow-lg"
                src={require("assets/img/icons8-iot-100.png")}
                style={{ width: "50px" }}
              />
              <UncontrolledTooltip placement="bottom" target="iot">
                The Internet of Things (IoT) refers to the vast network of
                physical objects from simple household items to complex
                industrial tools that are embedded with sensors, software, and
                other technologies for the purpose of connecting and exchanging
                data with other devices and systems over the internet.
              </UncontrolledTooltip>
            </Col>
            <Col className="mt-5 mt-sm-0" sm="3" xs="6" lg="4">
              <small className="d-block text-uppercase font-weight-bold mb-4">
                Web Development
              </small>
              <img
                id="web-development"
                alt="..."
                className="img-fluid rounded shadow pointer"
                src={require("assets/img/icons8-web-development-100.png")}
                style={{ width: "50px" }}
              />
              <UncontrolledTooltip placement="bottom" target="web-development">
                Web development is the process of building, programming, and
                maintaining websites and web applications. At C-HUB we work with
                various programming languages, such as HTML, CSS, and
                JavaScript/Typescript, React to develop websites and web
                applications.
              </UncontrolledTooltip>
            </Col>

            <Col className="mt-5 mt-sm-0" sm="3" xs="6" lg="4">
              <small className="d-block text-uppercase font-weight-bold mb-4">
                Software Development
              </small>
              <img
                id="software-development"
                alt="..."
                className="img-fluid rounded-circle shadow-lg"
                src={require("assets/img/icons8-software-development-100.png")}
                style={{ width: "50px" }}
              />
              <UncontrolledTooltip
                placement="bottom"
                target="software-development"
              >
                Software development is the process of creating, designing,
                testing, and maintaining software applications. It involves a
                variety of activities, including: Project conception,
                Requirements analysis, Software design, Coding, Testing,
                Deployment.
              </UncontrolledTooltip>
            </Col>
          </Row>
          <Row className="mt-5 mt-sm-5 text-center">
            <Col className="mt-5 mt-sm-0" sm="3" xs="6" lg="4">
              <small className="d-block text-uppercase font-weight-bold mb-4">
                API/Data Integration
              </small>
              <img
                id="system-integration"
                alt="..."
                className="img-fluid rounded shadow-lg"
                src={require("assets/img/icons8-module-100.png")}
                style={{ width: "50px" }}
              />
              <UncontrolledTooltip
                placement="bottom"
                target="system-integration"
              >
                System integration is the process of combining different systems
                and applications into a single, cohesive system that functions
                as one. The goal is to make these systems work together smoothly
                so they can share information and processes more efficiently. At
                C-HUB we provide the following system integrations API's,
                Payments, SMS, USSD, System to System.
              </UncontrolledTooltip>
            </Col>
            <Col className="mt-5 mt-sm-0" sm="3" xs="6" lg="4">
              <small className="d-block text-uppercase font-weight-bold mb-4">
                Mobile Development
              </small>
              <img
                id="mobile"
                alt="..."
                className="img-fluid rounded-circle shadow-lg"
                src={require("assets/img/icons8-android-phone-100.png")}
                style={{ width: "50px" }}
              />
              <UncontrolledTooltip placement="bottom" target="mobile">
                Mobile development is the process of creating software
                applications that run on mobile devices, such as smartphones,
                tablets, and digital assistants. The process involves several
                stages, including: ideation, design, coding, testing, and
                deployment. Art C-HUB we work with React Native to develop
                mobile applications.
              </UncontrolledTooltip>
            </Col>
            <Col className="mt-5 mt-sm-0" sm="3" xs="6" lg="4">
              <small className="d-block text-uppercase font-weight-bold mb-4">
                Project Management
              </small>
              <img
                id="project-management"
                alt="..."
                className="img-fluid rounded-circle shadow-lg"
                src={require("assets/img/icons8-project-management-100.png")}
                style={{ width: "50px" }}
              />
              <UncontrolledTooltip
                placement="bottom"
                target="project-management"
              >
                Project management is the process of planning, organizing, and
                executing a project to achieve its goals within the constraints
                of time, budget, and scope. It involves coordinating people and
                resources to meet deadlines and deliver a product, service, or
                deliverable. We can help your business with E2E project
                management from defining scopes, identifying deliverables and
                managing risk.
              </UncontrolledTooltip>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}
